import { render, staticRenderFns } from "./duoXingCollege.vue?vue&type=template&id=5f4baeda&scoped=true&"
import script from "./duoXingCollege.vue?vue&type=script&lang=js&"
export * from "./duoXingCollege.vue?vue&type=script&lang=js&"
import style0 from "./duoXingCollege.vue?vue&type=style&index=0&id=5f4baeda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4baeda",
  null
  
)

export default component.exports